import { Theme } from '@mui/material'

const useStyles = {
  userDetailsContainer: (theme: Theme) => ({
    padding: theme.spacing(0, 1),
    paddingY: 1.5,
    rowGap: 4,
    alignItems: 'center',
  }),
  mobileUserHeader: {
    marginBottom: 4,
  },
  nameRow: (theme: Theme) => ({
    [theme.breakpoints.up('sm')]: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
  }),
  userName: {
    marginBottom: { xs: 2, sm: 0 },
  },
  userDetailsDrawer: (theme: Theme) => ({
    backgroundColor: theme.palette.ui.surfaceContainer,
  }),
  contactDetailsCard: (theme: Theme, isMobile: boolean) => ({
    backgroundColor: theme.palette.common.white,
    borderRadius: '16px 16px 0 0',
    paddingRight: theme.spacing(2),
    paddingLeft: theme.spacing(2),
    paddingTop: isMobile ? 0 : 1,
    paddingBottom: isMobile ? 0 : 0.5,
  }),
  contactInfoHeader: {
    marginTop: 1,
  },
  contactInfoLabel: {
    fontWeight: '500',
  },
  phoneContainer: {
    columnGap: 4,
    marginTop: 2,
  },
  phoneDetails: {
    flex: '1',
  },
  emailContainer: {
    columnGap: 4,
    marginTop: 4,
    marginBottom: 2,
  },
  emailDetails: {
    flex: '1',
  },
  preferencesContainer: {
    marginTop: 1,
    marginBottom: 2,
  },
  preferencesIconContainer: {
    gap: '12px',
    marginTop: 1,
  },
  editBtn: (theme: Theme) => ({
    '&:not(.Mui-disabled) .MuiSvgIcon-root': {
      color: theme.palette.ui.brand01,
    },
    marginRight: theme.spacing(2),
  }),
  email: {
    wordWrap: 'break-word',
  },
}

export default useStyles
